import { render, staticRenderFns } from "./AdmissionQuery.vue?vue&type=template&id=d02235d6&scoped=true"
import script from "./AdmissionQuery.vue?vue&type=script&lang=js"
export * from "./AdmissionQuery.vue?vue&type=script&lang=js"
import style0 from "./AdmissionQuery.vue?vue&type=style&index=0&id=d02235d6&prod&lang=css"
import style1 from "./AdmissionQuery.vue?vue&type=style&index=1&id=d02235d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d02235d6",
  null
  
)

export default component.exports